import hydrate from '../lib/hydrate';
import CustomerCareEspot from '../lib/components/CustomerCare/CustomerCareEspot/CustomerCareEspot';

hydrate({
  frontend: 'CustomerCareEspotFrontend',
  component: CustomerCareEspot,
});
